import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';

import {
  RemoveAccessTokenAction,
  SetAccessTokenAction
} from './session.action';

export interface SessionStateModel {
  accessToken: string | null;
}

const SESSION_STATE_TOKEN = new StateToken<SessionStateModel>('session');

@State<SessionStateModel>({
  name: SESSION_STATE_TOKEN,
  defaults: {
    accessToken: null
  }
})
@Injectable()
export class SessionState {
  @Selector() static accessToken(
    state: SessionStateModel | undefined
  ): string | null {
    return state?.accessToken ?? null;
  }

  @Selector() static isAuthenticated(
    state: SessionStateModel | undefined
  ): boolean {
    return !!state?.accessToken;
  }

  @Action(SetAccessTokenAction) setAccessToken(
    ctx: StateContext<SessionStateModel>,
    { accessToken }: SetAccessTokenAction
  ): void {
    ctx.patchState({
      accessToken
    });
  }

  @Action(RemoveAccessTokenAction) removeAccessToken(
    ctx: StateContext<SessionStateModel>
  ): void {
    ctx.patchState({
      accessToken: null
    });
  }
}
